import React from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
import Terms from "./terms";
function FrequentAsked() {


  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title>Terms & Conditions | PMT</title>
        </MetaTags>

        <Row className="mb-10">
          <Col span={24}>
            <div className="terms-image">{/* PMTC */}</div>
          </Col>
          <Col span={24} >
            <div >
              <Terms />
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default FrequentAsked;
